// On Render the server serves this same build, so API calls can just stay
// relative to whatever origin the page was loaded from. The localhost
// fallback only matters for local dev, where the API runs on a separate port.
const API_URL =
  process.env.REACT_APP_API_URL || (process.env.NODE_ENV === "production" ? "" : "http://localhost:5001");

async function request(path, { method = "GET", body, token } = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      // Bypasses ngrok's free-tier browser-warning interstitial, which
      // otherwise intercepts plain fetch() calls (not just page loads) when
      // API_URL points at an ngrok tunnel and bounces them back as HTML.
      "ngrok-skip-browser-warning": "true",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Request failed");
  return data;
}

export const register = (name, password) =>
  request("/api/register", { method: "POST", body: { name, password } });

export const login = (name, password) =>
  request("/api/login", { method: "POST", body: { name, password } });

export const listGames = (token, gameType = "500") =>
  request(`/api/games?game=${encodeURIComponent(gameType)}`, { token });

export const getGameSummary = (token) => request("/api/game-summary", { token });

export const getRecord = (token, gameType = "500") =>
  request(`/api/record?game=${encodeURIComponent(gameType)}`, { token });

// `setup` carries the table size, whether it's listed publicly, the house
// rules, how partners are picked and whether to fill the empty seats with
// robots. A bare call still makes a two-player game, as it always did.
export const createGame = (token, setup = {}) =>
  request("/api/games", { method: "POST", token, body: setup });

export const getGameMeta = (token, id) => request(`/api/games/${id}/meta`, { token });

export const getGameDefaults = (token, mode, gameType = "500") =>
  request(`/api/game-defaults?mode=${mode}&game=${encodeURIComponent(gameType)}`, { token });

export const getStats = (token, mode, includeFriendly = false, gameType = "500") =>
  request(
    `/api/stats?mode=${mode}&includeFriendly=${includeFriendly ? "1" : "0"}&game=${encodeURIComponent(gameType)}`,
    { token }
  );
